// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3DwPr","errorLogs":"EditorFooter_errorLogs__2Adp_"};